(ns iris.websocket.handlers
  (:require [re-frame.core :as rf]
            [iris.data.websocket-impl :as ws-impl]))

;; Multimethod for handling different message types
(defmulti handle-ws-message 
  "Route WebSocket messages based on :type field"
  (fn [msg] (keyword (:type msg))))

(defmethod handle-ws-message :user_online
  [msg]
  (js/console.log "Handler: user_online" msg)
  (rf/dispatch [:iris.online-users/user-active (:fp_hash msg)]))

(defmethod handle-ws-message :online_users_list
  [msg]
  (js/console.log "Handler: online_users_list" msg)
  (rf/dispatch [:iris.online-users/set-list (:users msg) (:count msg)]))

(defmethod handle-ws-message :new_reply
  [msg]
  (js/console.log "Handler: new_reply" msg)
  (rf/dispatch [:iris.posts/new-reply msg]))

(defmethod handle-ws-message :vote_update
  [msg]
  (js/console.log "Handler: vote_update" msg)
  (rf/dispatch [:iris.posts/vote-update msg]))

(defmethod handle-ws-message :alert_check_result
  [msg]
  (js/console.log "Handler: alert_check_result" msg)
  (rf/dispatch [:iris.alerts/check-result msg]))

(defmethod handle-ws-message :posts_data
  [msg]
  (js/console.log "Handler: posts_data" msg)
  (ws-impl/resolve-posts-data! (:data msg)))

(defmethod handle-ws-message :default
  [msg]
  (js/console.warn "Unhandled WebSocket message type:" (:type msg) msg))

;; Re-frame effect for handling messages
(rf/reg-fx
 :ws/handle-message
 (fn [message]
   (handle-ws-message message)))

;; Event to receive and route messages
(rf/reg-event-fx
 :ws/message-received
 (fn [_ [_ message]]
   {:ws/handle-message message}))